import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            mx: 'auto',
            width: '100%',
            textAlign: 'center',
        },
        content: {
            '.swiper-pagination-bullet-active': {
                textDecoration: 'underline',
                textUnderlineOffset: remCalc(4),
            },
            '.swiper-pagination-bullet': {
                background: 'none',
                width: 'auto',
                height: 'auto',
                margin: '0 !important',
                cursor: 'pointer',
            },
            '.swiper-slide-active .swiper-button': {
                display: 'block',
            },
            '.cs-swiper-button-prev': {
                left: '8.33%',
                transform: 'translate(-50%, -50%)',
            },
            '.cs-swiper-button-next': {
                right: '8.33%',
                transform: 'translate(50%, -50%)',
            },

            '.cs-swiper-mobile': {
                display: 'flex',
                flexDirection: 'column-reverse',
            },

            '#mobile-pagination-container': {
                msOverflowStyle: 'none',
                scrollbarWidth: 'none',
                overflowX: {base: 'auto', md: 'hidden'},
            },
            '#mobile-pagination-container::-webkit-scrollbar': {
                display: 'none',
            },
        },
        pagination: {
            position: 'absolute',
            bottom: `min(7%, ${remCalc(78)}) !important`,
            width: '100%',
            zIndex: 2,
            justifyContent: 'center',
            gap: remCalc(46),
            textStyle: 'body-small',
            fontWeight: 'bold',
        },
        mobilePagination: {
            textStyle: 'body-small',
            fontWeight: 'bold',
            pt: {base: remCalc(24), md: remCalc(20)},
            pb: remCalc(24),
            justifyContent: {base: 'flex-start', md: 'space-between', lg: 'center'},
            gap: remCalc(46),
            minW: {base: 'max-content', md: 'unset'},
        },
        slide: {
            position: 'relative',
        },
        image: {
            h: '100%',
            minW: remCalc(343),
            minH: remCalc(240),
        },
        textblock: {
            top: 0,
            bottom: 0,
            justifyContent: 'center',
            alignItems: 'center',
            w: '100%',
        },
        label_paragraph: {
            textTransform: 'uppercase',
        },
        chevronIcon: {
            width: 'iconsSize.xlarge',
            height: 'iconsSize.xlarge',
            backgroundColor: 'background.default',
            borderRadius: '50%',
            cursor: 'pointer',
            zIndex: 2,
            position: 'absolute',
            top: '50%',
        },
        cta: {
            textDecoration: 'none !important',
            minW: {base: '100%', md: remCalc(310)},
        },
    },
}
